import React  from 'react'
import AssignmentStatusService from '../Services/AssignmentStatusService';
import ErrorMessage from './ErrorMessage';


export default class AssignmentStatusNameComponent extends React.Component 
{

    static defaultProps={
        id:0,
    };

    constructor(props) 
    {
        super(props);
        this.state = {
            name:props.id===null?"-":props.id
        };
    }

    componentDidMount() 
    {
        if(this.props.id===null) return;
        AssignmentStatusService.GetName(this.props.id)
            .then(result=>this.setState({name:result.lgsDesc}))
            .catch(error=>{
                ErrorMessage.SetErrorMessage("ASNC26", error)
            });
    }

    render()
    {
        
        return (
            <div>{this.state.name}</div>
        );
    }
}


